import { useAppState } from '../state/StateContext';
import InsuranceFormLeftInformation from './InsuranceFormLeftInformation';
import InsuranceFormReview from './InsuranceFormReview';
import InsuranceFormStep1 from './InsuranceFormStep1';
import InsuranceFormStep2 from './InsuranceFormStep2';
import InsuranceFormThankYou from './InsuranceFormThankYou';
import TransitionContainer from './TransitionContainer';

function InsuranceForm() {
  const state = useAppState();
  const step = state.formStep.get();

  return (
    <>
      <div className="row">
        <div className="col-md-4 col-xs-12">
          <InsuranceFormLeftInformation />
        </div>
        <div className="col-md-8 col-xs-12">
          <TransitionContainer show={step === 1} direction={0}>
            <InsuranceFormStep1 />
          </TransitionContainer>
          <TransitionContainer show={step === 2} direction={0}>
            <InsuranceFormStep2 />
          </TransitionContainer>
          <TransitionContainer show={step === 3} direction={0}>
            <InsuranceFormReview />
          </TransitionContainer>
          <TransitionContainer show={step === 4} direction={0}>
            <InsuranceFormThankYou />
          </TransitionContainer>
        </div>
      </div>
    </>
  );
}

export default InsuranceForm;
